import { render, staticRenderFns } from "./PreviewWhatsapp.vue?vue&type=template&id=4602e569&scoped=true&"
import script from "./PreviewWhatsapp.vue?vue&type=script&lang=js&"
export * from "./PreviewWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./PreviewWhatsapp.vue?vue&type=style&index=0&id=4602e569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4602e569",
  null
  
)

export default component.exports